export enum CUSTOMER {
    /**
     * @value Customer Preview users
     */
    CUSTOMER_PREVIEW_USERS = 'ADMIN.NAV.CUSTOMER_PREVIEW_USERS',
    /**
     * @value Platform settings
     */
    CUSTOMER_SETTINGS = 'ADMIN.NAV.CUSTOMER_SETTINGS',
    /**
     * @value Disabled
     * @description Text to display when an entity is on status Disabled
     */
    DISABLED = 'GLOBAL.DISABLED',
    /**
     * @value Enabled
     * @description Text to display when an entity is on status Enabled
     *
     */
    ENABLED = 'GLOBAL.ENABLED',
    /**
     * @value Global administrators
     */
    GLOBAL_ADMINS = 'ADMIN.NAV.SUPER_ADMINS',
    /**
     * @value Add a global administrator
     */
    GLOBAL_ADMIN_ADD = 'ADMIN_SUPER_ADMIN_ADD',
    /**
     * @value Delete a global administrator
     */
    GLOBAL_ADMIN_DELETE = 'ADMIN_SUPER_ADMIN_DELETE',
    /**
     * @value Are you sure you want to delete this administrator?
     */
    GLOBAL_ADMIN_DELETE_DESCRIPTION = 'ADMIN_SUPER_ADMIN_DELETE_DESCRIPTION',
    /**
     * @value Administrator deleted
     */
    GLOBAL_ADMIN_DELETE_SUCCESS = 'ADMIN_SUPER_ADMIN_DELETE_SUCCESS',
    /**
     * @value The platform will be %DETAILS%
     * @description Warning banner displayed at the bottom of the screen when the customer license is in the grace period. The parameter %DETAILS% is replaced by a bolded text indicating the remaining days before deletion.
     */
    GRACE_PERIOD_WARNING = 'CUSTOMER.GRACE_PERIOD_WARNING',
    /**
     * @value Customer sandbox
     * @description The customer_sandbox license
     */
    LICENSE_CUSTOMER_SANDBOX = 'CUSTOMER.LICENSE_CUSTOMER_SANDBOX',
    /**
     * @value Development
     * @description The development license
     */
    LICENSE_DEVELOPMENT = 'CUSTOMER.LICENSE_DEVELOPMENT',
    /**
     * @value permanently deleted in %DAYS% days.
     * @description Text used within the grace period warning banner. It replaces the %DETAILS% parameter in the parent key to apply bold formatting. The parameter %DAYS% represents the calculated number of days remaining.
     */
    LICENSE_GRACE_PERIOD_DELETION_DELAY = 'CUSTOMER.LICENSE_GRACE_PERIOD_DELETION_DELAY',
    /**
     * @value Production
     * @description The production license
     */
    LICENSE_PRODUCTION = 'CUSTOMER.LICENSE_PRODUCTION',
    /**
     * @value Your account has an outstanding balance. Please settle the invoice(s) to avoid service interruption. For any assistance, please contact your account representative or %SUPPORT_LINK%
     */
    PAYMENT_ISSUE_BANNER = 'CUSTOMER.PAYMENT_ISSUE_BANNER',
    /**
     * @value Pending
     */
    PENDING = 'GLOBAL.PENDING',
    /**
     * @value Find user
     */
    SEARCH_USERS = 'ADMIN_SUPER_ADMIN_SEARCH_USERS',
}
